export default "__VITE_ASSET__CSbSrl9n__ 720w";